import BaseApi from './BaseApi';

export type UserData = {
  channels?: Record<string, { readMarker: number }>;
  pins?: string[];
  agreement?: boolean;
  settings?: boolean;
  noticeReadMarker?: number;
};

/**
 * ユーザーデータAPI。
 */
class UserDataApi extends BaseApi {
  async get() {
    return await this.execute('userDataApi', {
      method: 'GET'
    }).then(({ result }) => result);
  }
  async set(data: Partial<UserData>) {
    return await this.execute('userDataApi', {
      method: 'PUT',
      body: data
    }).then(({ result }) => result as UserData);
  }
}

export default UserDataApi;
